import { useEffect } from 'react';

/*
 * Listens on the window rather than an element: the end of game screens have no
 * input to focus, so there is nothing for a key handler to hang off otherwise.
 */
export const useKeyDown = (keys: string[] | string, onKey: (key: string) => void): void => {
  useEffect(() => {
    const watchedKeys = typeof keys === 'string' ? [keys] : keys;

    const onWindowKeyDown = (keyboardEvent: KeyboardEvent): void => {
      const { key, repeat } = keyboardEvent;

      /* Ignore held-down repeats, which would otherwise deal game after game. */
      if (!watchedKeys.includes(key) || repeat) {
        return;
      }

      keyboardEvent.preventDefault();
      onKey(key);
    };

    window.addEventListener('keydown', onWindowKeyDown);

    return (): void => {
      window.removeEventListener('keydown', onWindowKeyDown);
    };
  }, [keys, onKey]);
};
